import type { HelpFile } from '../../types/help'
import { FooterTestIds } from '../../../testids/FooterTestIds'

export const footerHelp: HelpFile = {
  docPage: '/docs/about',
  texts: {
    [FooterTestIds.appFooter]:
      'Persistent footer that surfaces the running backend build version for tenant administrators and support engineers.',
    [FooterTestIds.footerVersion]:
      'Backend build version — useful for incident triage and release rollout monitoring.',
    [FooterTestIds.footerGitTag]:
      'Git tag of the running backend build — pinpoints the exact release artefact.',
    [FooterTestIds.footerGitBranch]:
      'Git branch the backend was built from — distinguishes mainline builds from feature branches.',
  },
}
